import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";
const DEFAULT_SECONDARY_COLOR = "var(--label-tertiary)";

const ROTATE_VALUE_TOP = 0;
const ROTATE_VALUE_RIGHT = 90;
const ROTATE_VALUE_BOTTOM = 180;
const ROTATE_VALUE_LEFT = 270;

enum BorderSide {
    Top = "top",
    Right = "right",
    Bottom = "bottom",
    Left = "left"
}

interface Props extends IconProps {
    side?: BorderSide;
}

function calculateRotationByPosition(side: BorderSide): number {
    switch (side) {
        case BorderSide.Top:
            return ROTATE_VALUE_TOP;
        case BorderSide.Right:
            return ROTATE_VALUE_RIGHT;
        case BorderSide.Bottom:
            return ROTATE_VALUE_BOTTOM;
        case BorderSide.Left:
            return ROTATE_VALUE_LEFT;
        // no default
    }
}

function IconBorderAlignment({
    class: cssClass,
    color,
    secondaryColor,
    side = BorderSide.Top
}: Props) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;
    const secondaryFill = secondaryColor ?? `var(--icon-secondary-color, ${DEFAULT_SECONDARY_COLOR})`;
    const rotation = calculateRotationByPosition(side);

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ transform: `rotate(${rotation}deg)` }} xmlns="http://www.w3.org/2000/svg">
            <path fill={secondaryFill} fill-rule="evenodd" d="M1 2v8.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V2h1v8.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 10.5V2h1z"/>
            <path fill={fill} fill-rule="evenodd" d="M0 .5A.5.5 0 0 1 .5 0h11a.5.5 0 0 1 0 1H.5A.5.5 0 0 1 0 .5z"/>
        </svg>
    );
}

export default IconBorderAlignment;
export { BorderSide };
